
/** --------------------------------------------------------------------------------------------------
 * 開啟'儲存中'視窗
 * -------------------------------------------------------------------------------------------------- */

window.showLoadingDialog = function() {

    $("#dialog-loading").show();

} // end of method

window.hideLoadingDialog = function() {

    $("#dialog-loading").hide();

} // end of method
